module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gl-pagination"
  }, [_c('ul', {
    staticClass: "pagination clearfix"
  }, _vm._l((_vm.getItems), function(item) {
    return _c('li', {
      class: {
        page: item.page,
          'js-previous-button': item.prev,
          'js-next-button': item.next,
          'js-last-button': item.last,
          'js-first-button': item.first,
          separator: item.separator,
          active: item.active,
          disabled: item.disabled
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changePage($event)
        }
      }
    }, [_vm._v(_vm._s(item.title))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-404deeca"}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/table_pagination.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-404deeca"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/table_pagination.vue
// module chunks = common_vue